import React, {useEffect} from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import get from 'get-value';
import {
    FORM_FIELD_CLIENT_ID,
    FORM_FIELD_DEALER_NAME,
    FORM_FIELD_DEALER_NO,
    FORM_FIELD_DESTINATION_CODE,
    FORM_FIELD_EMAIL,
    FORM_FIELD_TELEPHONE_NO,
    FORM_LABEL_CLIENT_ID,
    FORM_LABEL_DEALER_NAME,
    FORM_LABEL_DEALER_NO,
    FORM_LABEL_EMAIL,
    FORM_LABEL_TELEPHONE_NO,
    FORM_FIELD_CREATION_DATE,
    FORM_FIELD_DEALER_ADDRESS,
    FORM_LABEL_DEALER_ADDRESS,
    FORM_FIELD_COUNTRY,
    FORM_LABEL_COUNTRY,
    FORM_LABEL_DELIVERY_CONTACT_NAME,
    FORM_FIELD_DELIVERY_CONTACT_NAME,
    FORM_FIELD_EORI_NO,
    FORM_LABEL_EORI_NO,
    FORM_TICKET_SECTION
} from '../../../../../../constants/formConstants';
import {InputFieldWithValidation} from '../../../../../common/InputFieldWithValidation';
import InputSelectFieldWithValidation from '../../../../../common/InputSelectFieldWithValidation';
import {change, getFormInitialValues, formValueSelector} from 'redux-form';
import formMessages from '../../../../../../intl/sparePartsOrders/formMessages';
import {positiveNumber} from '../../../../../common/validationCommons';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const TicketSection = (props) => {
    const {change, clientIds, initialValues, userRights, readOnly, reqFields, createdInDic, processingDic, group } = props;
    const {ticketSection: {clientId}} = initialValues;

    if (userRights.canEditClientId && !readOnly && clientIds.length === 1 && !clientId && !createdInDic) {
        change(`${FORM_TICKET_SECTION}.${FORM_FIELD_CLIENT_ID}`, get(clientIds, '0.clientId', {default: ''}));
    }

    const handleChange = (event, value) => {
        change(`${FORM_TICKET_SECTION}.${FORM_FIELD_DESTINATION_CODE}`, get(clientIds.find(e => e.clientId === (value)), 'destinationCode', {default: ''}));
    };

    const clientIdOptions = clientIds.map((id) => id.clientId);

    useEffect(() => {
        if (!clientId) {
            change(`${FORM_TICKET_SECTION}.${FORM_FIELD_CLIENT_ID}`, get(clientIds, '0.clientId', { default: '' }));
            change(`${FORM_TICKET_SECTION}.${FORM_FIELD_COUNTRY}`, get(initialValues, 'ticketSection.group', { default: '' }));
        }
    }, []);

    return (
        <>
            <h3 className="text-left ml-4">
                <FormattedMessage {...formMessages.TICKET_SECTION}/>
            </h3>
            <StyledDiv className="border border-secondary px-4 py-2 bg-white">
                <div className="form-row">
                    <div className="col-xl-6 col-lg-8 col-md-12 col-12 pb-2">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_DEALER_NAME]}
                                                  field={FORM_FIELD_DEALER_NAME}
                                                  isDisabled
                                                  isSmall/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-12 pb-2">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_DEALER_ADDRESS]}
                                                  field={FORM_FIELD_DEALER_ADDRESS}
                                                  isRequired={reqFields.includes(FORM_FIELD_DEALER_ADDRESS) && !readOnly}
                                                  isDisabled={!userRights.canEditDealerAddress || readOnly}
                                                  isSmall/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-xl-3 col-lg-4 col-md-6 pb-2">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_COUNTRY]}
                                                  field={FORM_FIELD_COUNTRY}
                                                  placeholder="---"
                                                  isDisabled
                                                  isSmall/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-12 pb-2">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_DEALER_NO]}
                                                  field={FORM_FIELD_DEALER_NO} isDisabled
                                                  isSmall/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-12 pb-2">
                        <InputSelectFieldWithValidation label={formMessages[FORM_LABEL_CLIENT_ID]}
                                                        field={FORM_FIELD_CLIENT_ID}
                                                        options={clientIdOptions.filter((item, index) => clientIdOptions.indexOf(item) === index)}
                                                        isRequired={reqFields.includes(FORM_FIELD_CLIENT_ID) && !readOnly && get(clientIds, '0.type', '') !== 'NOT_USED'}
                                                        isDisabled={!userRights.canEditClientId || clientIdOptions.length <= 1 || readOnly || get(clientIds, '0.type', '') === 'NOT_USED' || createdInDic || processingDic}
                                                        handleChange={handleChange}
                                                        noEmpty
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-xl-4 col-lg-6 col-md-12 pb-2">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_EMAIL]}
                                                  field={FORM_FIELD_EMAIL}
                                                  isDisabled
                                                  isSmall/>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-md-12 pb-2">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_DELIVERY_CONTACT_NAME]}
                                                  field={FORM_FIELD_DELIVERY_CONTACT_NAME}
                                                  isRequired={reqFields.includes(FORM_FIELD_DELIVERY_CONTACT_NAME) && !readOnly}
                                                  isDisabled={!userRights.canEditDeliveryContactName || readOnly}
                                                  isSmall/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-xl-4 col-lg-6 col-md-12 pb-2">
                        {(get(initialValues, 'ticketSection.group', { default: '' }) === "GB" || get(initialValues, 'ticketSection.group', { default: '' }) === "IE") ?
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_EORI_NO]}
                                                  field={FORM_FIELD_EORI_NO}
                                                  isRequired={reqFields.includes(FORM_FIELD_EORI_NO) && !readOnly}
                                                  isDisabled={!userRights.canEditDealerAddress || readOnly}
                                                  isSmall/> : ""
                        }
                    </div>
                    <div className="col-xl-4 col-lg-6 col-md-12 pb-2">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_TELEPHONE_NO]}
                                                  field={FORM_FIELD_TELEPHONE_NO}
                                                  maxLength={15}
                                                  validations={[positiveNumber]}
                                                  isDisabled={!userRights.canEditTelNo || readOnly}
                                                  isRequired={reqFields.includes(FORM_FIELD_TELEPHONE_NO) && !readOnly}
                                                  isSmall/>
                    </div>
                </div>
            </StyledDiv>
        </>
    )
};

const mapStateToProps = (state, props) => ({
    clientIds: state.adminClientIds.clientIds,
    initialValues: getFormInitialValues(props.form)(state),
    createdInDic: state.sparePartsOrderTicket.ticket.createdInDic,
    processingDic: state.sparePartsDic.isCreateOrUpdateDicLoading,
    creationDate: formValueSelector(props.form)(state, `${FORM_TICKET_SECTION}.${FORM_FIELD_CREATION_DATE}`),
    selectedClientId: formValueSelector(props.form)(state, `${FORM_TICKET_SECTION}.${FORM_FIELD_CLIENT_ID}`),
    group: state.profile.userDetail.group,
});

const mapDispatchToProps = (dispatch, props) => ({
    change: (name, value) => dispatch(change(props.form, name, value)),
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(TicketSection));
